import { BrowserModule } from "@angular/platform-browser";
import { NgModule, LOCALE_ID } from "@angular/core";
import { HttpModule, XHRBackend, BrowserXhr, JsonpModule } from "@angular/http";
import { MyXHRBackend } from "./MyXHRBackend";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import * as $ from "jquery";
import "../styles/styles.scss";

//VALIDATION
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DatePickerModule } from "angular-io-datepicker";

//ROTAS
import { AppRoutingModule } from "./app-routing/app-routing.module";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";

//TEMPLATES
import { HeaderComponent } from "./header/component/header.component";
import { FooterComponent } from "./footer/component/footer.component";

//PAGES
import { LoginComponent } from "./login/component/login.component";
import { CockpitComponent } from "./cockpit/component/cockpit/cockpit.component";
import { CockpitCreditProposalComponent } from "./cockpit/component/cockpit/credit-proposal/credit-proposal.component";
import { CockpitAditionalCreditProposalComponent } from "./cockpit/component/cockpit/aditional-credit-proposal/aditional-credit-proposal.component";
import { CockpitCommercialCompetenceComponent } from "./cockpit/component/cockpit/commercial-competence-proposal/commercial-competence.component";
import { CockpitAllowanceProposalComponent } from "./cockpit/component/cockpit/allowance-proposal/allowance-proposal.component";
import { CockpitProlongationProposalComponent } from "./cockpit/component/cockpit/prolongation-proposal/prolongation-proposal.component";
import { AnalysisSummaryComponent } from "./cockpit/component/cockpit/analysis-summary/analysis-summary.component";
import { UserListComponent } from "./user/component/user-list/user-list.component";
import { UserEditComponent } from "./user/component/user-edit/user-edit.component";
import { GroupEditComponent } from "./group/component/group-edit/group-edit.component";
import { AccountClientListComponent } from "./account-client/component/account-client-list/account-client-list.component";
import { AccountClientDetailsComponent } from "./account-client/component/account-client-details/account-client-details.component";
import { AccountClientByCodeComponent } from "./account-client/component/account-client-bycode/account-client-bycode.component";
import { PhoneNumberComponent } from "./account-client/component/account-client-details/phone-number.component";
import { UserInsertComponent } from "./user/component/user-insert/user-insert.component";
import { CultureComponent } from "./limit-flow-proposal/component/limit-flow-proposal/culture/culture.component";
import { ClientTypeListComponent } from "./client-type/component/client-type-list/client-type-list.component";
import { ClientTypeInsertComponent } from "./client-type/component/client-type-insert/client-type-insert.component";
import { ClientTypeEditComponent } from "./client-type/component/client-type-edit/client-type-edit.component";
import { GroupInsertComponent } from "./group/component/group-insert/group-insert.component";
import { GroupListComponent } from "./group/component/group-list/group-list.component";

import { CollectStatusListComponent } from "./collect-status/component/collect-status-list/collect-status-list.component";
import { CollectStatusInsertComponent } from "./collect-status/component/collect-status-insert/collect-status-insert.component";
import { CollectStatusEditComponent } from "./collect-status/component/collect-status-edit/collect-status-edit.component";

//PAGINATION
import { SegmentListComponent } from "./segments/component/segment-list/segment-list.component";
import { SegmentInsertComponent } from "./segments/component/segment-insert/segment-insert.component";
import { SegmentEditComponent } from "./segments/component/segment-edit/segment-edit.component";
import { LogListComponent } from "./log/component/log-list/log-list.component";
import { LogSapComponent } from "./logsap/component/logsap/logsap.component";
import { AccountClientLogComponent } from "./account-client/component/account-client-log/account-client-log.component";
import { BillingConceptListComponent } from "./billing-concept/component/billing-concept-list/billing-concept-list.component";
import { BillingConceptEditComponent } from "./billing-concept/component/billing-concept-edit/billing-concept-edit.component";
import { BillingConceptInsertComponent } from "./billing-concept/component/billing-concept-insert/billing-concept-insert.component";
import { UiComponentComponent } from "./ui-component/ui-component.component";
import { YaraPaginationComponent } from "./pagination/pagination.component";
import { CultureListComponent } from "./culture/component/culture-list/culture-list.component";
import { CultureEditComponent } from "./culture/component/culture-edit/culture-edit.component";
import { CultureInsertComponent } from "./culture/component/culture-insert/culture-insert.component";
import { ExperienceListComponent } from "./experience/component/experience-list/experience-list.component";
import { ExperienceEditComponent } from "./experience/component/experience-edit/experience-edit.component";
import { ExperienceInsertComponent } from "./experience/component/experience-insert/experience-insert.component";
import { RevenueTypeListComponent } from "./revenue-type/component/revenue-type-list/revenue-type-list.component";
import { RevenueTypeEditComponent } from "./revenue-type/component/revenue-type-edit/revenue-type-edit.component";
import { RevenueTypeInsertComponent } from "./revenue-type/component/revenue-type-insert/revenue-type-insert.component";
import { CompanyTypeListComponent } from "./company-type/component/company-type-list/company-type-list.component";
import { CompanyTypeEditComponent } from "./company-type/component/company-type-edit/company-type-edit.component";
import { CompanyTypeInsertComponent } from "./company-type/component/company-type-insert/company-type-insert.component";
import { GuaranteeTypeInsertComponent } from "./guarantee-type/component/guarantee-type-insert/guarantee-type-insert.component";
import { GuaranteeTypeListComponent } from "./guarantee-type/component/guarantee-type-list/guarantee-type-list.component";
import { GuaranteeTypeEditComponent } from "./guarantee-type/component/guarantee-type-edit/guarantee-type-edit.component";
import { AreaListComponent } from "./area/component/area-list/area-list.component";
import { AreaEditComponent } from "./area/component/area-edit/area-edit.component";
import { AreaInsertComponent } from "./area/component/area-insert/area-insert.component";
import { ProductListComponent } from "./product/component/product-list/product-list.component";
import { ProductEditComponent } from "./product/component/product-edit/product-edit.component";
import { ProductInsertComponent } from "./product/component/product-insert/product-insert.component";
import { AverageageofsugarcaneListComponent } from "./averageageofsugarcane/component/averageageofsugarcane-list/averageageofsugarcane-list.component";
import { AverageageofsugarcaneEditComponent } from "./averageageofsugarcane/component/averageageofsugarcane-edit/averageageofsugarcane-edit.component";
import { AverageageofsugarcaneInsertComponent } from "./averageageofsugarcane/component/averageageofsugarcane-insert/averageageofsugarcane-insert.component";
import { UnitofmeasurementcultureListComponent } from "./unitofmeasurementculture/component/unitofmeasurementculture-list/unitofmeasurementculture-list.component";
import { UnitofmeasurementcultureEditComponent } from "./unitofmeasurementculture/component/unitofmeasurementculture-edit/unitofmeasurementculture-edit.component";
import { UnitofmeasurementcultureInsertComponent } from "./unitofmeasurementculture/component/unitofmeasurementculture-insert/unitofmeasurementculture-insert.component";
import { ProductivityListComponent } from "./productivity/component/productivity-list/productivity-list.component";
import { ProductivityEditComponent } from "./productivity/component/productivity-edit/productivity-edit.component";
import { ProductivityInsertComponent } from "./productivity/component/productivity-insert/productivity-insert.component";
import { PercentageofbreakListComponent } from "./percentageofbreak/component/percentageofbreak-list/percentageofbreak-list.component";
import { PercentageofbreakEditComponent } from "./percentageofbreak/component/percentageofbreak-edit/percentageofbreak-edit.component";
import { PercentageofbreakInsertComponent } from "./percentageofbreak/component/percentageofbreak-insert/percentageofbreak-insert.component";
import { PriceListComponent } from "./price/component/price-list/price-list.component";
import { PriceEditComponent } from "./price/component/price-edit/price-edit.component";
import { PriceInsertComponent } from "./price/component/price-insert/price-insert.component";
import { LivestocktypeListComponent } from "./livestocktype/component/livestocktype-list/livestocktype-list.component";
import { LivestocktypeEditComponent } from "./livestocktype/component/livestocktype-edit/livestocktype-edit.component";
import { LivestocktypeInsertComponent } from "./livestocktype/component/livestocktype-insert/livestocktype-insert.component";
import { CostharegionListComponent } from "./costharegion/component/costharegion-list/costharegion-list.component";
import { CostharegionEditComponent } from "./costharegion/component/costharegion-edit/costharegion-edit.component";
import { CostharegionInsertComponent } from "./costharegion/component/costharegion-insert/costharegion-insert.component";
import { MovecustomerstructureComponent } from "./movecustomerstructure/component/movecustomerstructure/movecustomerstructure.component";
import { ParametersComponent } from "./parameters/component/parameters/parameters.component";
import { ReasonOfAllowanceInsertComponent } from "./reason-of-allowance/component/reason-of-allowance-insert/reason-of-allowance-insert.component";
import { ReasonOfAllowanceListComponent } from "./reason-of-allowance/component/reason-of-allowance-list/reason-of-allowance-list.component";
import { ReasonOfAllowanceEditComponent } from "./reason-of-allowance/component/reason-of-allowance-edit/reason-of-allowance-edit.component";
import { ReasonOfExtensionInsertComponent } from "./reason-of-extension/component/reason-of-extension-insert/reason-of-extension-insert.component";
import { ReasonOfExtensionListComponent } from "./reason-of-extension/component/reason-of-extension-list/reason-of-extension-list.component";
import { ReasonOfExtensionEditComponent } from "./reason-of-extension/component/reason-of-extension-edit/reason-of-extension-edit.component";
import { MonitorComponent } from "./monitor/component/monitor.component";

//LOADER
import { NgProgressModule } from "ngx-progressbar";
import { NgProgressBrowserXhr } from "ngx-progressbar";

//MESSAGES
import { FlashMessagesModule } from "angular2-flash-messages";
import { TypeOfIndebtednessListComponent } from "./type-of-indebtedness/component/type-of-indebtedness-list/type-of-indebtedness-list.component";
import { TypeOfIndebtednessEditComponent } from "./type-of-indebtedness/component/type-of-indebtedness-edit/type-of-indebtedness-edit.component";
import { TypeOfIndebtednessInsertComponent } from "./type-of-indebtedness/component/type-of-indebtedness-insert/type-of-indebtedness-insert.component";
import { CommercialStructureListComponent } from "./commercial-structure/component/commercial-structure-list/commercial-structure-list.component";
import { CommercialStructureInsertComponent } from "./commercial-structure/component/commercial-structure-insert/commercial-structure-insert.component";
import { CommercialStructureEditComponent } from "./commercial-structure/component/commercial-structure-edit/commercial-structure-edit.component";
import { OrderDetailComponent } from "./order/component/order-detail/order-detail.component";
import { OrderListComponent } from "./order/component/order-list/order-list.component";
import { UnauthorizedComponent } from "./unauthorized/component/unauthorized.component";
import { AttachmentListComponent } from "./attachment/component/attachment-list/attachment-list.component";
import { AttachmentEditComponent } from "./attachment/component/attachment-edit/attachment-edit.component";
import { AttachmentInsertComponent } from "./attachment/component/attachment-insert/attachment-insert.component";
import { LimitFlowProposalComponent } from "./limit-flow-proposal/component/limit-flow-proposal/limit-flow-proposal.component";
import { ReferenceComponent } from "./limit-flow-proposal/component/limit-flow-proposal/reference/reference.component";
import { AttachmentsenderComponent } from "./attachmentsender/component/attachmentsender/attachmentsender.component";
import { LimiteAdicionalAttachmentsenderComponent } from "./attachmentsender/component/limite-adicional-attachmentsender/limite-adicional-attachmentsender.component";
import { DatexPipe } from "./datex.pipe";
import { DocumentPipe } from "./document.pipe";
import { ArraySortPipe } from "./sort.pipe";
import { OrderBy } from "./orderby.pipe";
import { GroupingRemoverPipe } from "./grouping-remover.pipe";
import { ClientCodePipe } from "./codigocliente.pipe";
import { TextMaskModule } from "angular2-text-mask/dist/angular2TextMask";
import { Ng2BRPipesModule } from "ng2-brpipes";
import { HolidaysInsertComponent } from "./holidays/component/holidays-insert/holidays-insert.component";
import { BootstrapModalModule } from "ng2-bootstrap-modal";
import { ConfirmComponent } from "./shared/confirm/confirm.component";
import { AlertComponent } from "./shared/alert/alert.component";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { PatrimonyComponent } from "./limit-flow-proposal/component/patrimony/patrimony.component";
import { ApprovalCommitteeComponent } from "./limit-flow-proposal/component/approval-committee/approval-committee.component";
import { ApprovalCommitteeLAComponent } from "./limite-adicional-proposal/component/approval-committee-la/approval-committee-la.component";
import { FindOrderComponent } from "./find-order/component/find-order.component";
import { AccountClientSimplifiedComponent } from "./account-client-simplified/component/account-client-simplified/account-client-simplified.component";
import { EconomicGroupComponent } from "./economic-group/component/economic-group/economic-group.component";
import { EconomicGroupFlowComponent } from "./economic-group-flow/component/economic-group-flow/economic-group-flow.component";
import { RelationsComponent } from "./relations/component/relations/relations.component";
import { EconomicGroupCreateComponent } from "./economic-group/component/economic-group-create/economic-group-create.component";
import { RevenueComponent } from "./limit-flow-proposal/component/revenue/revenue.component";
import { LiveStockComponent } from "./limit-flow-proposal/component/limit-flow-proposal/livestock/livestock.component";
import { OtherRevenueComponent } from "./limit-flow-proposal/component/limit-flow-proposal/other-revenue/other-revenue.component";
import { SendToCtcComponent } from "./limit-flow-proposal/component/actions/send-to-ctc/send-to-ctc.component";
import { ProfileUserComponent } from "./profile-user/component/profile-user/profile-user.component";
import { RequestPendingComponent } from "./limit-flow-proposal/component/actions/request-pending/request-pending.component";
import { RequestPendingApprovalComponent } from "./limit-flow-proposal/component/actions/request-pending-approval/request-pending-approval.component";
import { RequestPendingWarrantyComponent } from "./limit-flow-proposal/component/actions/request-pending-warranty/request-pending-warranty.component";
import { StateCultureListComponent } from "./stateculture/component/stateculture-list/stateculture-list.component";
import { StateCultureEditComponent } from "./stateculture/component/stateculture-edit/stateculture-edit.component";
import { StateCultureInsertComponent } from "./stateculture/component/stateculture-insert/stateculture-insert.component";
import { TypeOfIndebtednessComponent } from "./limit-flow-proposal/component/limit-flow-proposal/type-of-indebtedness/type-of-indebtedness.component";
import { GuaranteeComponent } from "./limit-flow-proposal/component/limit-flow-proposal/guarantee/guarantee.component";
import { PatrimonyModalComponent } from "./limit-flow-proposal/component/limit-flow-proposal/patrimony-modal/patrimony-modal.component";
import { RevenueModalComponent } from "./limit-flow-proposal/component/limit-flow-proposal/revenue-modal/revenue-modal.component";
import { EconomicGroupEditComponent } from "./economic-group/component/economic-group-edit/economic-group-edit.component";
import { EconomicGroupInsertUserComponent } from "./economic-group/component/economic-group-insert-user/economic-group-insert-user.component";
import { SummaryComponent } from "./limit-flow-proposal/component/summary/summary.component";
import { RatingComponent } from "./limit-flow-proposal/component/rating/rating.component";
import { FinancialDemosComponent } from "./limit-flow-proposal/component/limit-flow-proposal/financial-demos/financial-demos.component";
import { EconomicGroupDetailComponent } from "./economic-group/component/economic-group-detail/economic-group-detail.component";
import { RelationTypeEditComponent } from "./relations/component/relations-edit/relations-edit.component";
import { RelationTypeInsertComponent } from "./relations/component/relations-insert/relations-insert.component";
import { SerasaComponent } from "./serasa/component/serasa/serasa.component";
import { ConcentreComponent } from "./serasa/component/serasa/concentre/concentre.component";
import { RelatoComponent } from "./serasa/component/serasa/relato/relato.component";
import { CrednetComponent } from "./serasa/component/serasa/crednet/crednet.component";
import { EconomicGroupLimitComponent } from "./limit-flow-proposal/component/limit-flow-proposal/economic-group-limit/economic-group-limit.component";
import { OrdersComponent } from "./account-client/component/account-client-details/orders/orders.component";
import { SerasaConfirmComponent } from "./account-client/component/account-client-details/serasa-confirm/serasa-confirm.component";
import { SolicitarLcAdicionalComponent } from "./account-client/component/account-client-details/solicitar-lc-adicional/solicitar-lc-adicional.component";
import { ProposalApproverComponent } from "./proposal-approver/component/proposal-approver/proposal-approver.component";
import { AditionalProposalApproverComponent } from "./aditional-proposal-approver/component/aditional-proposal-approver/aditional-proposal-approver.component";
import { LimitFlowSalesOrderComponent } from "./limit-flow-sales-order/component/sales-order/sales-order.component";
import { BillingControlComponent } from "./billing-control/billing-control/billing-control.component";
import { BlogComponent } from "./limit-flow-proposal/component/blog/blog.component";
import { BcGeneralComponent } from "./billing-control/billing-control/bc-general/bc-general.component";
import { BcEffectiveComponent } from "./billing-control/billing-control/bc-effective/bc-effective.component";
import { BcEffectiveCultureComponent } from "./billing-control/billing-control/bc-effective-culture/bc-effective-culture.component";
import { BcEffectiveStateComponent } from "./billing-control/billing-control/bc-effective-state/bc-effective-state.component";
import { BcExpired110Component } from "./billing-control/billing-control/bc-expired-1-x/bc-expired-1-x.component";
import { BcLargestDebtorsComponent } from "./billing-control/billing-control/bc-largest-debtors/bc-largest-debtors.component";
import { BcSentToJuridicalComponent } from "./billing-control/billing-control/bc-sent-to-juridical/bc-sent-to-juridical.component";
import { BcClientListComponent } from "./billing-control/bc-client-list/bc-client-list.component";
import { BcAccountClientComponent } from "./billing-control/bc-account-client/bc-account-client.component";
import { BcBillingListComponent } from "./billing-control/bc-account-client/bc-billing-list/bc-billing-list.component";
import { CommentModalComponent } from "./billing-control/bc-account-client/bc-billing-list/bc-billing-list-integral/comment-modal/comment-modal.component";
import { AttTitleModalComponent } from "./billing-control/bc-account-client/bc-billing-list/att-title-modal/att-title-modal.component";
import { BcBillingListIntegralComponent } from "./billing-control/bc-account-client/bc-billing-list/bc-billing-list-integral/bc-billing-list-integral.component";
import { BcExtensionProposalComponent } from "./billing-control/bc-account-client/bc-extension-proposal/bc-extension-proposal.component";
import { BcEconomicGroupComponent } from "./billing-control/bc-account-client/bc-economic-group/bc-economic-group.component";
import { BcAllowanceProposalComponent } from "./billing-control/bc-account-client/bc-allowance-proposal/bc-allowance-proposal.component";
import { BcJudicialProposalComponent } from "./billing-control/bc-account-client/bc-juridical-proposal/bc-juridical-proposal.component";
import { BcFilterListComponent } from "./billing-control/bc-filter/bc-filter.component";
import { BcEffectiveStatusComponent } from "./billing-control/billing-control/bc-effective-status/bc-effective-status.component";
import { ChartsModule } from "ng2-charts/ng2-charts";
import { ChartComponent } from "./shared/chart/chart.component";
import { AttachmentAccountClientComponent } from "./account-client/component/account-client-details/attachment-account-client/attachment-account-client.component";
import { BcPropertySearchComponent } from "./billing-control/bc-account-client/bc-property-search/bc-property-search.component";
import { BcVisitationComponent } from "./billing-control/bc-account-client/bc-visitation/bc-visitation.component";
import { FixedLimitComponent } from "./limit-flow-proposal/component/fixed-limit/fixed-limit.component";
import { FixedLimitLAComponent } from "./limite-adicional-proposal/component/fixed-limit-la/fixed-limit-la.component";
import { BcApCommitteeComponent } from "./billing-control/bc-account-client/bc-allowance-proposal/bc-ap-committee/bc-ap-committee.component";
import { BcApAttachmentComponent } from "./billing-control/bc-account-client/bc-allowance-proposal/bc-ap-attachment/bc-ap-attachment.component";
import { BcApBlogComponent } from "./billing-control/bc-account-client/bc-allowance-proposal/bc-ap-blog/bc-ap-blog.component";
import { LimitFlowAllowanceComponent } from "./limit-flow-allowance/component/limit-flow-allowance/limit-flow-allowance.component";
import { LimitFlowReprieveComponent } from "./limit-flow-reprieve/component/limit-flow-reprieve/limit-flow-reprieve.component";
import { BcJAttachmentComponent } from "./billing-control/bc-account-client/bc-juridical-proposal/bc-j-attachment/bc-j-attachment.component";
import { BcECommitteeComponent } from "./billing-control/bc-account-client/bc-extension-proposal/bc-e-committee/bc-e-committee.component";
import { BcEAttachmentComponent } from "./billing-control/bc-account-client/bc-extension-proposal/bc-e-attachment/bc-e-attachment.component";
import { BcEBlogComponent } from "./billing-control/bc-account-client/bc-extension-proposal/bc-e-blog/bc-e-blog.component";
import { MoneySourceListComponent } from "./money-source/component/money-source-list/money-source-list.component";
import { MoneySourceInsertComponent } from "./money-source/component/money-source-insert/money-source-insert.component";
import { MoneySourceEditComponent } from "./money-source/component/money-source-edit/money-source-edit.component";
import { BcExtensionModalComponent } from "./billing-control/bc-account-client/bc-billing-list/bc-extension-modal/bc-extension-modal.component";
import { BcAllowanceModalComponent } from "./billing-control/bc-account-client/bc-billing-list/bc-allowance-modal/bc-allowance-modal.component";
import { OrdersModalComponent } from "./account-client/component/account-client-details/orders/orders-modal/orders-modal.component";
import { OrderRequisitionsComponent } from "./order-requisitions/order-requisitions/order-requisitions.component";
import { ProposalViewModalComponent } from "./account-client/component/account-client-details/proposal-view-modal/proposal-view-modal.component";
import { LcProposalViewComponent } from "./account-client/component/account-client-details/proposal-view-modal/LCproposal-view/lc-proposal-view.component";
import { LaProposalViewComponent } from "./account-client/component/account-client-details/proposal-view-modal/LAproposal-view/la-proposal-view.component";
import { JdProposalViewComponent } from "./account-client/component/account-client-details/proposal-view-modal/JDproposal-view/jd-proposal-view.component";
import { AbProposalViewComponent } from "./account-client/component/account-client-details/proposal-view-modal/ABproposal-view/ab-proposal-view.component";
import { EtProposalViewComponent } from "./account-client/component/account-client-details/proposal-view-modal/ETproposal-view/et-proposal-view.component";
import { BcApCtcSelectorComponent } from "./billing-control/bc-account-client/bc-allowance-proposal/bc-ap-ctc-selector/bc-ap-ctc-selector.component";
import { BcEreasonSelectorComponent } from "./billing-control/bc-account-client/bc-extension-proposal/bc-e-committee/bc-e-committee-reason/bc-e-committee-reason.component";
import { BcEreasonBillingComponent } from "./billing-control/bc-account-client/bc-extension-proposal/bc-e-committee/bc-e-billing-reason/bc-e-billing-reason.component";
import { GuarantessAccountClientComponent } from "./account-client/component/account-client-details/guarantees-account-client/guarantees-account-client.component";
import { InsertGuaranteeModalComponent } from "./account-client/component/account-client-details/guarantees-account-client/insert-guarantee-account-client/insert-guarantee-modal.component";
import { BcInsuranceModalComponent } from "./billing-control/bc-account-client/bc-insurance-modal/bc-insurance-modal.component";
import { CommercialCompetenceComponent } from "./commercial-competence/commercial-competence/commercial-competence.component";
import { CcCultureComponent } from "./commercial-competence/commercial-competence/cc-culture/cc-culture.component";
import { ProposalComponent } from "./report/component/proposal/proposal.component";
import { LimitFlowProposalService } from "./limit-flow-proposal/service/limit-flow-proposal/limit-flow-proposal.service";
import { CcSerasaModalComponent } from "./commercial-competence/commercial-competence/cc-serasa-modal/cc-serasa-modal.component";
import { AcProposalViewComponent } from "./account-client/component/account-client-details/proposal-view-modal/ACproposal-view/ac-proposal-view.component";
import { AlcadaAlertComponent } from "./account-client/component/account-client-details/alcada-alert/alcada-alert.component";
import { MyDatePickerModule } from "mydatepicker";
import { ProposalLogComponent } from "./limit-flow-proposal/component/log/proposal-log.component";
import { CompetenceProposalLogComponent } from "./commercial-competence/commercial-competence/log/proposal-log.component";
import { GuaranteeSummaryModalComponent } from "./limit-flow-proposal/component/summary/guarantee-modal/guarantee-modal.component";
import { ReferenceSummaryModalCommponent } from "./limit-flow-proposal/component/summary/reference-modal/reference-modal.component";
import { CcSerasaModalLCComponent } from "./limit-flow-proposal/component/limit-flow-proposal/cc-serasa-modal-lc/cc-serasa-modal-lc.component";
import { AttachmentGridComponent } from "./account-client/component/account-client-details/attachment-account-client/attachment-grid/attachment-grid.component";
import { Ng2GoogleChartsModule } from "ng2-google-charts";
import { OrderViewModalComponent } from "./account-client/component/account-client-details/order-view-modal/order-view-modal.component";
import { BulkRenewalRequestComponent } from "./bulk-renewal/component/bulk-renewal-request/bulk-renewal-request.component";
import { BulkRenewalComponent } from "./bulk-renewal/component/bulk-renewal/bulk-renewal.component";
import { RenewalModalComponent } from "./bulk-renewal/component/bulk-renewal-request/renewal-modal/renewal-modal.component";
import { BulkRenewalFlowComponent } from "./bulk-renewal-flow/component/bulk-renewal-flow/bulk-renewal-flow.component";
import { BulkRenewalRequestService } from "./bulk-renewal/component/bulk-renewal-request/service/bulk-renewal-request.service";
import { BulkRenewalProposalComponent } from "./cockpit/component/cockpit/bulk-renewal-proposal/bulk-renewal-proposal.component";
import { RvProposalVewComponent } from "./account-client/component/account-client-details/proposal-view-modal/rv-proposal-vew/rv-proposal-vew.component";
import { EditLcComponent } from "./account-client/component/account-client-details/edit-lc/edit-lc.component";
import { FinancialHistoryComponent } from "./account-client/component/account-client-details/financial-history/financial-history.component";
import { LogsArchivingComponent } from "./logs-archiving/component/logs-archiving.component";
import { LimiteAdicionalProposalComponent } from "./limite-adicional-proposal/component/limite-adicional-proposal/limite-adicional-proposal.component";
import { LimiteAdicionalProposalService } from "./limite-adicional-proposal/service/limite-adicional-proposal/limite-adicional-proposal.service";
import { SendLaToCtcComponent } from "./limite-adicional-proposal/component/actions/send-la-to-ctc/send-la-to-ctc.component";
import { AnalysisApproverComponent } from "./analysis-approver/component/analysis-approver/analysis-approver.component";
import { AcceptanceApproverComponent } from "./acceptance-approver/component/acceptance-approver/acceptance-approver.component";
import { RedirectFlowCommitteeModalComponent } from './limit-flow-proposal/component/limit-flow-proposal/redirect-flow-committee-modal/redirect-flow-committee-modal/redirect-flow-committee-modal.component';
import { SummaryTableComponent } from "./cockpit/component/cockpit/summary-table/summary-table.component";
import { SummaryTableExpandedComponent } from "./cockpit/component/cockpit/summary-table/summary-table-expanded/summary-table-expanded.component";
import { ApprovalSummaryComponent } from "./cockpit/component/cockpit/approval-summary/approval-summary.component";
import { CheckboxMultiselectComponent } from "./shared/checkbox-multiselect/checkbox-multiselect.component";
import { GcMultiselectComponent } from "./cockpit/component/cockpit/gc-multiselect/component/gc-multiselect.component";
import { AttachmentListService } from "./attachment/service/attachment-list/attachment-list.service";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    UserListComponent,
    UserEditComponent,
    GroupEditComponent,
    AccountClientListComponent,
    AccountClientDetailsComponent,
    AccountClientByCodeComponent,
    PhoneNumberComponent,
    UserInsertComponent,
    ClientTypeListComponent,
    ClientTypeInsertComponent,
    ClientTypeEditComponent,
    GroupInsertComponent,
    GroupListComponent,
    SegmentListComponent,
    SegmentInsertComponent,
    SegmentEditComponent,
    LogListComponent,
    LogSapComponent,
    AccountClientLogComponent,
    BillingConceptListComponent,
    BillingConceptEditComponent,
    BillingConceptInsertComponent,
    UiComponentComponent,
    YaraPaginationComponent,
    CultureListComponent,
    CultureEditComponent,
    CultureInsertComponent,
    StateCultureListComponent,
    StateCultureEditComponent,
    StateCultureInsertComponent,
    ExperienceListComponent,
    ExperienceEditComponent,
    ExperienceInsertComponent,
    RevenueTypeListComponent,
    RevenueTypeEditComponent,
    RevenueTypeInsertComponent,
    CompanyTypeListComponent,
    CompanyTypeEditComponent,
    CompanyTypeInsertComponent,
    GuaranteeTypeInsertComponent,
    GuaranteeTypeListComponent,
    GuaranteeTypeEditComponent,
    AreaListComponent,
    AreaEditComponent,
    AreaInsertComponent,
    ProductListComponent,
    ProductEditComponent,
    ProductInsertComponent,
    AverageageofsugarcaneListComponent,
    AverageageofsugarcaneEditComponent,
    AverageageofsugarcaneInsertComponent,
    UnitofmeasurementcultureListComponent,
    UnitofmeasurementcultureEditComponent,
    UnitofmeasurementcultureInsertComponent,
    ProductivityListComponent,
    ProductivityEditComponent,
    ProductivityInsertComponent,
    PercentageofbreakListComponent,
    PercentageofbreakEditComponent,
    PercentageofbreakInsertComponent,
    PriceListComponent,
    PriceEditComponent,
    PriceInsertComponent,
    LivestocktypeListComponent,
    LivestocktypeEditComponent,
    LivestocktypeInsertComponent,
    CostharegionListComponent,
    CostharegionEditComponent,
    CostharegionInsertComponent,
    MovecustomerstructureComponent,
    ParametersComponent,
    CockpitComponent,
    CockpitCreditProposalComponent,
    CockpitAditionalCreditProposalComponent,
    CockpitCommercialCompetenceComponent,
    CockpitAllowanceProposalComponent,
    CockpitProlongationProposalComponent,
    AnalysisSummaryComponent,
    ApprovalSummaryComponent,
    TypeOfIndebtednessListComponent,
    TypeOfIndebtednessEditComponent,
    TypeOfIndebtednessInsertComponent,
    CommercialStructureListComponent,
    CommercialStructureInsertComponent,
    CommercialStructureEditComponent,
    OrderDetailComponent,
    OrderListComponent,
    UnauthorizedComponent,
    LimitFlowProposalComponent,
    LimiteAdicionalProposalComponent,
    CultureComponent,
    AttachmentListComponent,
    AttachmentEditComponent,
    AttachmentInsertComponent,
    ReferenceComponent,
    AttachmentsenderComponent,
    LimiteAdicionalAttachmentsenderComponent,
    LimitFlowSalesOrderComponent,
    DatexPipe, //Pipe to format Data
    DocumentPipe,
    ArraySortPipe,
    OrderBy,
    GroupingRemoverPipe,
    ClientCodePipe,
    HolidaysInsertComponent,
    ConfirmComponent,
    AlertComponent,
    PatrimonyComponent,
    ApprovalCommitteeComponent,
    ApprovalCommitteeLAComponent,
    FindOrderComponent,
    AccountClientSimplifiedComponent,
    EconomicGroupComponent,
    EconomicGroupFlowComponent,
    RelationsComponent,
    EconomicGroupCreateComponent,
    RevenueComponent,
    LiveStockComponent,
    OtherRevenueComponent,
    ProfileUserComponent,
    TypeOfIndebtednessComponent,
    GuaranteeComponent,
    PatrimonyModalComponent,
    RevenueModalComponent,
    CommentModalComponent,
    AttTitleModalComponent,
    EconomicGroupEditComponent,
    EconomicGroupInsertUserComponent,
    SummaryComponent,
    EconomicGroupDetailComponent,
    RelationTypeEditComponent,
    RelationTypeInsertComponent,
    RatingComponent,
    FinancialDemosComponent,
    EconomicGroupLimitComponent,
    SerasaComponent,
    ConcentreComponent,
    RelatoComponent,
    CrednetComponent,
    OrdersComponent,
    SerasaConfirmComponent,
    SolicitarLcAdicionalComponent,
    SendToCtcComponent,
    SendLaToCtcComponent,
    RequestPendingComponent,
    RequestPendingApprovalComponent,
    RequestPendingWarrantyComponent,
    AcceptanceApproverComponent,
    AnalysisApproverComponent,
    ProposalApproverComponent,
    AditionalProposalApproverComponent,
    BillingControlComponent,
    BlogComponent,
    BcGeneralComponent,
    BcEffectiveComponent,
    BcEffectiveCultureComponent,
    BcEffectiveStateComponent,
    BcExpired110Component,
    BcLargestDebtorsComponent,
    BcSentToJuridicalComponent,
    BcClientListComponent,
    BcAccountClientComponent,
    BcBillingListComponent,
    BcBillingListIntegralComponent,
    BcExtensionProposalComponent,
    BcEconomicGroupComponent,
    BcAllowanceProposalComponent,
    BcJudicialProposalComponent,
    BcFilterListComponent,
    BcEffectiveStatusComponent,
    ChartComponent,
    CollectStatusListComponent,
    CollectStatusInsertComponent,
    CollectStatusEditComponent,
    AttachmentAccountClientComponent,
    BcPropertySearchComponent,
    BcVisitationComponent,
    FixedLimitComponent,
    FixedLimitLAComponent,
    LimitFlowAllowanceComponent,
    LimitFlowReprieveComponent,
    BcApCommitteeComponent,
    BcApAttachmentComponent,
    BcApBlogComponent,
    ReasonOfAllowanceInsertComponent,
    ReasonOfAllowanceListComponent,
    ReasonOfAllowanceEditComponent,
    BcJAttachmentComponent,
    BcECommitteeComponent,
    BcEAttachmentComponent,
    BcEBlogComponent,
    ReasonOfExtensionInsertComponent,
    ReasonOfExtensionListComponent,
    ReasonOfExtensionEditComponent,
    MoneySourceListComponent,
    MoneySourceInsertComponent,
    MoneySourceEditComponent,
    BcExtensionModalComponent,
    BcAllowanceModalComponent,
    OrdersModalComponent,
    OrderRequisitionsComponent,
    ProposalViewModalComponent,
    LcProposalViewComponent,
    LaProposalViewComponent,
    JdProposalViewComponent,
    AbProposalViewComponent,
    EtProposalViewComponent,
    BcApCtcSelectorComponent,
    BcEreasonSelectorComponent,
    BcEreasonBillingComponent,
    GuarantessAccountClientComponent,
    InsertGuaranteeModalComponent,
    BcInsuranceModalComponent,
    CommercialCompetenceComponent,
    CcCultureComponent,
    ProposalComponent,
    CcSerasaModalComponent,
    CcSerasaModalLCComponent,
    AcProposalViewComponent,
    AlcadaAlertComponent,
    ProposalLogComponent,
    CompetenceProposalLogComponent,
    GuaranteeSummaryModalComponent,
    ReferenceSummaryModalCommponent,
    AttachmentGridComponent,
    MonitorComponent,
    OrderViewModalComponent,
    BulkRenewalRequestComponent,
    BulkRenewalFlowComponent,
    BulkRenewalComponent,
    RenewalModalComponent,
    BulkRenewalProposalComponent,
    RvProposalVewComponent,
    EditLcComponent,
    FinancialHistoryComponent,
    LogsArchivingComponent,
    RedirectFlowCommitteeModalComponent,
    SummaryTableComponent,
    SummaryTableExpandedComponent,
    CheckboxMultiselectComponent,
    GcMultiselectComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    DatePickerModule,
    NgProgressModule,
    FlashMessagesModule,
    TextMaskModule,
    Ng2BRPipesModule,
    BootstrapModalModule,
    CurrencyMaskModule,
    JsonpModule,
    ChartsModule,
    MyDatePickerModule,
    Ng2GoogleChartsModule,
  ],
  providers: [
    { provide: BrowserXhr, useClass: NgProgressBrowserXhr },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: XHRBackend, useClass: MyXHRBackend },
    { provide: LOCALE_ID, useValue: "pt-BR" },
    LimitFlowProposalService, //Define the locale to configurations based on the active locale
    LimiteAdicionalProposalService,
    BulkRenewalRequestService,
    AttachmentListService,
  ],
  entryComponents: [
    ConfirmComponent,
    AlertComponent,
    EconomicGroupCreateComponent,
    PatrimonyModalComponent,
    RevenueModalComponent,
    CommentModalComponent,
    AttTitleModalComponent,
    EconomicGroupInsertUserComponent,
    ConcentreComponent,
    RelatoComponent,
    CrednetComponent,
    SerasaConfirmComponent,
    SolicitarLcAdicionalComponent,
    SendToCtcComponent,
    SendLaToCtcComponent,
    RequestPendingComponent,
    RequestPendingApprovalComponent,
    RequestPendingWarrantyComponent,
    BcClientListComponent,
    BcPropertySearchComponent,
    BcVisitationComponent,
    FixedLimitComponent,
    FixedLimitLAComponent,
    BcAllowanceModalComponent,
    OrdersModalComponent,
    ProposalViewModalComponent,
    OrderViewModalComponent,
    BcApCtcSelectorComponent,
    BcEreasonSelectorComponent,
    BcEreasonBillingComponent,
    InsertGuaranteeModalComponent,
    BcInsuranceModalComponent,
    BcExtensionModalComponent,
    CcSerasaModalComponent,
    CcSerasaModalLCComponent,
    AlcadaAlertComponent,
    GuaranteeSummaryModalComponent,
    ReferenceSummaryModalCommponent,
    RenewalModalComponent,
    EditLcComponent,
    RedirectFlowCommitteeModalComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts